import { FormContext, FormInputOptions, OptionsFormField } from "../components.ts";
import { React, useContext, useState } from "../deps/remix.ts";
import { useBindings } from "~/hooks/use-bindings.ts";

const ContributionOptionsField: React.FC = () => {
  const manager = useContext(FormContext)!;

  const opts = {
    2500: {
      id: "2500",
      label: "$25",
    },
    5000: {
      id: "5000",
      label: "$50",
      isDefault: true,
    },
    10000: {
      id: "10000",
      label: "$100",
    },
    25000: {
      id: "25000",
      label: "$250",
    },
    50000: {
      id: "50000",
      label: "$500",
    },
    100000: {
      id: "100000",
      label: "$1000",
    },
  } as FormInputOptions;

  const [showOtherInput, setShowOtherInput] = useState(false);
  return (
    <div>
      <label style={{ fontWeight: "bold", fontSize: "15px" }}>SELECT CONTRIBUTION AMOUNT</label>

      <OptionsFormField
        name="contribution_amount"
        options={opts}
        cssClasses="--contribute"
        onChangeCallback={() => {
          setShowOtherInput(false);
        }}
        renderOption={(opt, field, input) => {
          return (
            <label key={opt.id}>
              {input}
              <span>{opt.label}</span>
            </label>
          );
        }}
      >
        {
          <label key={"contribution_amount_custom"}>
            <input
              type="radio"
              autoComplete="off"
              checked={showOtherInput}
              name="contribution_amount"
              id="contribution_amount_custom"
              onChange={(e) => {
                if (e.target.checked) {
                  manager.setValue("contribution_amount", "");
                  setShowOtherInput(true);
                }
              }}
            />{" "}
            <span>
              Other
            </span>
          </label>
        }
        {showOtherInput && (
          <label className="FormField__Label --w-100" style={{ marginTop: "16px" }}>
            <div style={{ fontWeight: "bold" }}>Enter Custom Contribution Amount</div>
            <input
              className="FormField__Input"
              type="number"
              step="1"
              min="0"
              pattern="[0-9]*"
              onChange={(e) => {
                const val = (parseInt(e.target.value) * 100).toString();
                manager.setValue(
                  "contribution_amount",
                  val,
                );
                document.querySelector("input#contribution_amount_custom")!.value = val;
              }}
            />
          </label>
        )}
      </OptionsFormField>
    </div>
  );
};

export default ContributionOptionsField;
